import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useT } from '@/lib/i18n';

export const LegalLayout = ({ titleFr, titleEn, children }) => {
  const { lang } = useT();
  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <header className="border-b border-white/5 px-6 lg:px-12 py-5">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white">
          <ArrowLeft className="w-4 h-4" /> {lang === 'fr' ? 'Retour' : 'Back'}
        </Link>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-12 lg:py-16">
        <h1 className="font-heading text-4xl sm:text-5xl font-black mb-8 leading-tight">{lang === 'fr' ? titleFr : titleEn}</h1>
        <div className="prose prose-invert max-w-none space-y-6 text-zinc-300 leading-relaxed [&_h2]:font-heading [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-white [&_h2]:mt-10 [&_h2]:mb-4 [&_a]:text-[#D4FF00] [&_a:hover]:underline [&_strong]:text-white">
          {children}
        </div>
        <p className="mt-16 text-xs text-zinc-600 font-mono">{lang === 'fr' ? 'Dernière mise à jour : Février 2026' : 'Last updated: February 2026'}</p>
      </main>
    </div>
  );
};
